import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { ITheme } from '../../../themer';
import { Color } from '../../../../styles/Color';
import { Css } from '../../../utils';

export const SelectPlaceholder = styled.div<
	{ hasMultiselectCount?: boolean },
	ITheme
>`
	color: ${Color.Neutral6};
	font-size: ${Css.pxToRem(16)};
	font-weight: 500;

	${({ hasMultiselectCount }) =>
		hasMultiselectCount &&
		css`
			display: flex;
			justify-content: space-between;
		`}
`;
